import {NgModule} from "@angular/core"
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http"
import {UnauthorizedResponseInterceptor} from "app/common/services/http/interceptors/UnauthorizedResponseInterceptor"
import {HttpErrorInterceptor} from "app/common/services/http/interceptors/HttpErrorInterceptor"

@NgModule({
    imports: [
        HttpClientModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UnauthorizedResponseInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        HttpClient
    ]
})
export class HttpModule {

}
